import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import kmiStore from "./kmi.store";
import bappebtiStore from "../components/bappebti/bappebti.store";
import vaultStore from "./vault.store";
import offExchangeStore from "./offexchange.store";
import baseAPIVMS from "../services/baseApiVms";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        login: "",
        minute: "",
        status_login: null,
        geoData: [],
    },

    getters: {
        getStatusLogin(state) {
            return state.status_login;
        },
    },
    mutations: {
        Login(state, payload) {
            state.login = payload;
        },
        set_interval(state, payload) {
            state.minute = payload;
        },
        LoginStatus(state, payload) {
            state.status_login = payload;
        },
        setGeoData(state, payload) {
            state.geoDatas = payload;
        },
    },
    actions: {
        getLocation({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("https://asia-southeast1-quiet-stacker-245710.cloudfunctions.net/get-user-access-location")
                    .then((res) => {
                        resolve(res.data);
                        commit("setGeoData", res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async NewLogin({commit}, params) {
            try{
                const resGeo = await axios.get("https://asia-southeast1-quiet-stacker-245710.cloudfunctions.net/get-user-access-location");
                let latLong = resGeo.data.cityLatLong.split(",");
                const res = await Promise.all([
                    axios.post("/v2/auth", params, {
                        headers: {
                            Latitude: latLong[0],
                            Longitude: latLong[1],
                            City: resGeo.data.city,
                            Region: resGeo.data.region,
                            Country: resGeo.data.country,
                            "IP-Address": resGeo.data.userIP,
                        },
                    }),
                    baseAPIVMS.post('/user/login', params)
                ]);

                const responseAuthOld = res[0];
                const responseAuthVMS = res[1];
                commit("LoginStatus", responseAuthOld.data.data.status_code);
                const token = responseAuthOld.data.data.token;
                const username = responseAuthOld.data.data.username;
                const role = responseAuthOld.data.data.role;
                const user_id = responseAuthOld.data.data.user_id;
                if (responseAuthOld.status == 200) {
                    sessionStorage.setItem("role", role);
                    sessionStorage.setItem("token", token);
                    sessionStorage.setItem("username", username);
                    sessionStorage.setItem("user_id", user_id);
                    sessionStorage.setItem("status_token", true);
                    sessionStorage.setItem("refreshTokenTime", Date.now() + 90000);
                }

                if(responseAuthVMS.status == 200){
                    const tokenVMS = responseAuthVMS.data.data.token;
                    sessionStorage.setItem("token_vms", tokenVMS);
                }
            
            }catch(error){
                console.error("Error occurred while fetching location data:", error);
                commit("LoginStatus", error.response.data.data.status_code);
            }
        },
        LOGIN({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    // .get("https://asia-southeast2-kbi-prod.cloudfunctions.net/get-user-access-location")
                    .get("https://asia-southeast1-quiet-stacker-245710.cloudfunctions.net/get-user-access-location")
                    .then((resGeo) => {
                        let latLong = resGeo.data.cityLatLong.split(",");
                        axios
                            .post("/v2/auth", data, {
                                headers: {
                                    Latitude: latLong[0],
                                    Longitude: latLong[1],
                                    City: resGeo.data.city,
                                    Region: resGeo.data.region,
                                    Country: resGeo.data.country,
                                    "IP-Address": resGeo.data.userIP,
                                },
                            })
                            .then((res) => {
                                commit("LoginStatus", res.data.data.status_code);
                                const token = res.data.data.token;
                                const username = res.data.data.username;
                                const role = res.data.data.role;
                                const user_id = res.data.data.user_id;
                                if (res.status == 200) {
                                    sessionStorage.setItem("role", role);
                                    sessionStorage.setItem("token", token);
                                    sessionStorage.setItem("username", username);
                                    sessionStorage.setItem("user_id", user_id);
                                    sessionStorage.setItem("status_token", true);
                                    sessionStorage.setItem("refreshTokenTime", Date.now() + 90000);
                                }
                                commit("Login", res);
                                resolve();
                            })
                            .catch((error) => {
                                commit("LoginStatus", error.response.data.data.status_code);
                                reject(error);
                            });
                    });
            });
        },

        setMinute({ commit }) {
            commit("set_interval", false);
            sessionStorage.setItem("set_minute", false);
            sessionStorage.removeItem("newtoken");
            setInterval(() => {
                commit("set_interval", true);
                sessionStorage.setItem("set_minute", true);
            }, 10 * 1000);
        },
    },
    modules: {
        kmiModule: kmiStore,
        bappebtiModule: bappebtiStore,
        vaultModul: vaultStore,
        offExchangeModul: offExchangeStore
    },
});
